/* eslint-disable import/no-anonymous-default-export */
import React from "react";

export default () => {
  const clearStorageAndCache = () => {
    // Wyczyść dane z pamięci podręcznej przeglądarki
    if (typeof window !== "undefined" && "caches" in window) {
      caches.keys().then(function (cacheNames) {
        cacheNames.forEach(function (cacheName) {
          caches.delete(cacheName);
        });
      });
    }
  };

  const isClearStorageAndCache = async (): Promise<boolean> => {
    if (typeof window !== "undefined") {
      if (localStorage.length > 0) {
        return true;
      }

      if ("caches" in window) {
        const cacheNames = await caches.keys();
        if (cacheNames.length > 0) {
          return true;
        }
      }
    }

    return false;
  };

  React.useEffect(() => {
    isClearStorageAndCache().then((shouldClear) => {
      if (shouldClear) {
        clearStorageAndCache();
      }
    });
    //eslint-disable-next-line
  }, []);
};